import React from 'react';

const TermsOfService = () => {
  return (
    <div className="space-y-6 text-gray-700 font-poppins">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-rateiq-blue mb-2">TERMS OF SERVICE</h1>
        <div className="text-sm text-gray-500">
          Effective Date: June 1st, 2025
        </div>
      </div>

      <div className="leading-relaxed">
        <p className="mb-6">
          Welcome to RateIQ. These Terms of Service ("Terms") govern your use of our website and services (collectively, the "Services"). By accessing or using the Services, you agree to be bound by these Terms.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">1. Eligibility and Acceptance</h3>
        <p className="leading-relaxed">
          You represent and warrant that you are of legal age in your jurisdiction and have the authority to enter into these Terms. If you are using the Services on behalf of an entity, you represent that you have authority to bind that entity.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">2. User Data and License Grant</h3>
        
        <div className="mb-4">
          <h4 className="text-lg font-medium text-gray-800 mb-2">a. Data Submission</h4>
          <p className="leading-relaxed mb-3">
            By uploading or submitting any data, files, documents, or information, including but not limited to merchant processing statements ("User Data"), you grant Rate IQ a non-exclusive, worldwide, royalty-free, perpetual, irrevocable, transferable, and sublicensable license to:
          </p>
          <ul className="list-disc list-inside space-y-2 leading-relaxed ml-4">
            <li>Use, store, reproduce, host, display, distribute, analyze, modify, and create derivative works from the User Data;</li>
            <li>Use such data for any lawful business purposes, including benchmarking, analytics, internal development, marketing, and commercial monetization, including sale or licensing to third parties in de-identified or aggregated form.</li>
          </ul>
        </div>

        <div className="mb-4">
          <h4 className="text-lg font-medium text-gray-800 mb-2">b. Data Anonymization</h4>
          <p className="leading-relaxed">
            We will take reasonable steps to anonymize or aggregate any User Data before using or sharing it for external purposes, in compliance with the Personal Information Protection and Electronic Documents Act (PIPEDA) and other applicable laws. We do not sell or disclose personally identifiable information (PII) unless required by law or with your consent.
          </p>
        </div>

        <div>
          <h4 className="text-lg font-medium text-gray-800 mb-2">c. Ownership and Responsibility</h4>
          <p className="leading-relaxed">
            You retain ownership of the User Data you submit. However, you agree that RateIQ may use that data as described above without obligation to notify you or provide compensation. You represent and warrant that you have all rights, permissions, and authority to provide the User Data and that its use by us will not infringe any third-party rights or violate any laws or agreements.
          </p>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">3. Data Retention</h3>
        <p className="leading-relaxed">
          We may retain User Data for as long as legally permitted, including after account closure or service termination, for purposes consistent with this Agreement and applicable law.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">4. Privacy</h3>
        <p className="leading-relaxed">
          Your privacy is important to us. Please review our [Privacy Policy] for more information about how we collect, use, and protect your personal information. By using the Services, you consent to such collection and use.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">5. Disclaimers</h3>
        <p className="leading-relaxed">
          The Services are provided "as is" and "as available." We make no warranties or guarantees regarding accuracy, availability, or outcomes of any analysis. You use the Services at your own risk. We disclaim all warranties, express or implied, including any warranties of merchantability, fitness for a particular purpose, or non-infringement.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">6. Limitation of Liability</h3>
        <p className="leading-relaxed">
          To the fullest extent permitted by law, RateIQ shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or data, arising from or related to your use of the Services.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">7. Indemnification</h3>
        <p className="leading-relaxed mb-3">
          You agree to indemnify and hold harmless [Your Company Name], its directors, officers, employees, and affiliates from any claims, losses, damages, liabilities, and expenses arising from:
        </p>
        <ul className="list-disc list-inside space-y-2 leading-relaxed ml-4">
          <li>Your use of the Services;</li>
          <li>Your breach of these Terms;</li>
          <li>Your violation of any third-party rights or applicable laws.</li>
        </ul>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">8. Termination</h3>
        <p className="leading-relaxed">
          We may suspend or terminate your access to the Services at any time, with or without notice, for any reason, including violation of these Terms.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">9. Changes to Terms</h3>
        <p className="leading-relaxed">
          We reserve the right to modify these Terms at any time. Updates will be posted on this page and take effect upon posting. Continued use of the Services after such changes constitutes your acceptance.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">10. Governing Law and Jurisdiction</h3>
        <p className="leading-relaxed">
          These Terms are governed by the laws of the Province of Ontario and the laws of Canada, without regard to conflict of laws principles. Any disputes shall be resolved exclusively in the courts located in Ontario.
        </p>
      </div>

      <div>
        <h3 className="text-xl font-medium text-rateiq-blue mb-3">11. Entire Agreement</h3>
        <p className="leading-relaxed">
          These Terms, along with our Privacy Policy, constitute the entire agreement between you and RateIQ regarding your use of the Services and supersede any prior agreements or understandings.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService; 